export default __webpack_public_path__ + "static/top_pc-d020c1e4cde453c5543ec33b8d72e2de.png";